import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import DialogTitleBar from "../../common/DialogTitleBar";
import MbrasWhdwlApply from "./change/MbrasWhdwlApply";
import MbrasSearchDialog from "./dialog/MbrasSearchDialog";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";

const MbrasWhdwlMng = () => {
  const userInfo = useRecoilValue(Atom.userInfo);

  const [keyword, setKeyword] = React.useState("");
  const [searchAtrzSttsCd, setSearchAtrzSttsCd] = React.useState("");
  const [upOgnzCd, _setUpOgnzCd] = React.useState<string>(userInfo.upOgnzCd);
  const [ognzCd,   _setOgnzCd] = React.useState<string>(userInfo.ognzCd);
  const [ocptTypeCd, setOcptTypeCd] = React.useState("");
  const [sttDt, setSttDt] = React.useState("");
  const [endDt, setEndDt] = React.useState("");

  const [dataArr, setDataArr] = React.useState<any[]>([]);

  const [modalOpen, setModalOpen] = React.useState(false);
  const [searchModalOpen, setSearchModalOpen] = React.useState(false);

  const [callTime, setCallTime] = React.useState<Date>(new Date());
  const [mbrasId, setMbrasId] = React.useState<string>("");
  const [pickedMbrasNm, setPickedMbrasNm] = React.useState<string>("");
  const [mbrasAtrzDocId, setMbrasAtrzDocId] = React.useState<string>("");

  const [mode, setMode] = React.useState<"NEW" | "MOD">("NEW");

  const fldInfs: fldInfsProps[] = [
    { type: "seq", width: 50, headAlign: "center", dataAlign: "center", label: "No." },
    { type: "text", fldNm: "mbrasId", width: 120, headAlign: "center", dataAlign: "center", label: "조합원번호" },
    { type: "text", fldNm: "mbrasNm", width: 90, headAlign: "center", dataAlign: "center", label: "성명" },
    { type: "text", fldNm: "atrzSttsNm", width: 100, headAlign: "center", dataAlign: "center", label: "상태" },
    { type: "text", fldNm: "upOgnzNm", width: 120, headAlign: "center", dataAlign: "center", label: "본부" },
    { type: "text", fldNm: "ognzNm", width: 120, headAlign: "center", dataAlign: "center", label: "지부" },
    { type: "text", fldNm: "wtjrNm", width: 160, headAlign: "center", dataAlign: "center", label: "관내" },
    { type: "text", fldNm: "ocptTypeNm", width: 110, headAlign: "center", dataAlign: "center", label: "직종" },
    { type: "text", fldNm: "crtDt", width: 110, headAlign: "center", dataAlign: "center", label: "작성일자" },
  ];

  React.useEffect(() => {
    // 작성일자 검색 조건 확인
    if (Util.isNotEmpty(sttDt) && Util.isNotEmpty(endDt)) {
        if (sttDt > endDt) {
            AppContext.openAlert({ 
                title: "작성일자 검색 조건 확인", 
                msg: "작성일자의 검색 시작일자가 종료일자보다 느립니다.", 
                icon: "warning" 
            }); 
            setEndDt("")
            return;
        } 
    }
    AppContext.showSpinner();
    Axios.dataAccess({
      url: "system/mbras/whdwl/select-mbras-whdwl-list.do",
      methodType: "post",
      paramType: "json",
      paramData: {
        searchAtrzSttsCd: searchAtrzSttsCd,
        upOgnzCd      : ognzCd === "00_000" ? "" : upOgnzCd,
        ognzCd        : ognzCd.includes("000") ? "" : ognzCd, // 지방본부(000): 해당 지방본부만
        ocptTypeCd    : ocptTypeCd,
        sttDt         : sttDt,
        endDt         : endDt,
      },
      onSuccessFn: (res: any) => {
        setDataArr(res.result.list);
        AppContext.hideSpinner();
      },
    });
  }, [callTime, searchAtrzSttsCd, upOgnzCd, ognzCd, ocptTypeCd, sttDt, endDt]);

  return (
    <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
      <div className="mt5">
        <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">탈퇴 등록/수정</span>
        <div className="bdt3 bdc007bff pb10"></div>
      </div>

      <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
        <div className="dpFlx aiC gap14 flxWrap">
          <div className="dpFlx aiC ">
            <span className="w40 fm-c fs15 fc333333 ls1 taL">성명</span>
            <TextBox
              value={keyword}
              width={120}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              style={{ backgroundColor: "#fff", padding: "0 10px" }}
              placeholder="성명 입력"
              onChangeFunc={(text: string) => setKeyword(text)}
            />
          </div>

          <div className="dpFlx aiC">
            <span className="w40 fm-c fs15 fc333333 ls1 taL">상태</span>
            <SelectBox
              value={searchAtrzSttsCd}
              width={100}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              background="#fff"
              codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("UI_ATRZ_STTS_CD_01"))}
              placeholder="전체"
              paddingRight={8}
              onChangeFunc={(v: string) => setSearchAtrzSttsCd(v)}
            />
          </div>

          <div className="dpFlx aiC">
            <span className="w40 fm-c fs15 fc333333 ls1 taL">직종</span>
            <SelectBox
              value={ocptTypeCd}
              width={150}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              background="#fff"
              codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("OCPT_TYPE_CD"))}
              placeholder="전체"
              paddingRight={8}
              onChangeFunc={(v: string) => setOcptTypeCd(v)}
            />
          </div>

          <div className="dpFlx aiC">
            <span className="w70 fm-c fs15 fc333333 ls1 taL">작성일자</span>
            <DatePickerBox
              width={150}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              bgColor="white"
              textAlign="left"
              calendarThemeColor={AppContext.themeColor}
              className="mr5"
              value={sttDt}
              onChange={(v: string) => setSttDt(v)}
            />
            <span className="fm-c fc666666 mr5">~</span>
            <DatePickerBox
              width={150}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              bgColor="white"
              textAlign="left"
              calendarThemeColor={AppContext.themeColor}
              className="mr5"
              value={endDt}
              onChange={(v: string) => setEndDt(v)}
            />
          </div>

          <div className="dpFlx aiC mlA">
            <Button
              width={75}
              height={40}
              fontFamily="fm-b"
              fontSize={16}
              letterSpacing={-1}
              variant="styInitBtn"
              borderRadius={6}
              buttonClass="dpFlx aiC jcC"
              buttonName="초기화"
              onClickFunc={() => {
                setKeyword("");
                setSearchAtrzSttsCd("");
                setOcptTypeCd("");
                setSttDt("");
                setEndDt("");
              }}
            />
          </div>
        </div>
      </div>

      <div className="dpFlx aiC jcSb mb10 h44">
        <div className="fm-b fs16 fc007bff ls1 fw700">
          <span>조합원 목록</span>
        </div>

        <Button
          width={150}
          height={40}
          fontFamily="fm-b"
          fontSize={16}
          letterSpacing={-1}
          variant="styDeleteBtn"
          borderRadius={6}
          buttonClass="dpFlx aiC jcC"
          buttonName="탈퇴 등록"
          onClickFunc={() => {
            // if (ognzCd === "00_000") {
            //     AppContext.openAlert({
            //     title: "등록 권한 안내",
            //     msg: "조합본부 관리자는 탈퇴 등록을 진행할 수 없습니다.",
            //     icon: "warning",
            //     });
            //     return;
            // }
            // 지부인 경우 모달 오픈
            setMode("NEW");
            setMbrasId("");
            setPickedMbrasNm("");
            setMbrasAtrzDocId("");
            setSearchModalOpen(true);
          }}
        />
      </div>

      <GridTable
        tableInfo={{
          tableHeadVsb: true,
          styleType: AdminGridStyle,
          fldInfs: fldInfs,
          ordFld: { name: "mbrasId", direction: "desc" },
          dataArr: Util.filterFieldData(dataArr as any, fldInfs, "mbrasNm", keyword),
          maxRowNums: [10, 20, 30],
          theadTrHeight: 40,
          tbodyTrHeight: 35,
          paginateClass: "pt10",
          paginateStyle: {
            buttonOnColor: AppContext.boardThemeColor,
            buttonWidth: 22,
            buttonHeight: 24,
            buttonMarginLeft: 1,
            buttonMarginRight: 1,
            fontSize: 13,
            color: "#666666",
            letterSpacing: -0.8,
            fontFamily: "Pretendard-Regular",
            borderRadius: 3,
          },
          footerVsb: true,
          rowClickFunc: (item: any) => {
            setMode("MOD");
            setMbrasId(String(item.mbrasId || ""));
            setPickedMbrasNm(String(item.mbrasNm || ""));
            setMbrasAtrzDocId(String(item.mbrasAtrzDocId || ""));
            setModalOpen(true);
          },
        }}
      />

      <Modal
        modalOpen={searchModalOpen}
        dim={true}
        visible={true}
        titleEl={<DialogTitleBar title={"탈퇴 조합원 선택"} backgroundColor={AppContext.themeColor} />}
        onCloseFunc={() => {
          setSearchModalOpen(false);
        }}
      >
        <div className="h560">
          <MbrasSearchDialog
            setModalOpen={setSearchModalOpen}
            setCallTime={setCallTime}
            onPick={(row: any) => {
              setMode("NEW");
              setMbrasId(String(row.mbrasId || ""));
              setPickedMbrasNm(String(row.mbrasNm || ""));
              setMbrasAtrzDocId("");
              setSearchModalOpen(false);
              setModalOpen(true);
            }}
          />
        </div>
      </Modal>

      <Modal
        modalOpen={modalOpen}
        dim={true}
        visible={true}
        titleEl={<DialogTitleBar title={mode === "NEW" ? "탈퇴 등록" : "탈퇴 수정"} backgroundColor={AppContext.themeColor} />}
        onCloseFunc={() => {
          setMbrasId("");
          setPickedMbrasNm("");
          setMbrasAtrzDocId("");
          setModalOpen(false);
        }}
      >
        <div className="h540">
          <MbrasWhdwlApply
            mode={mode}
            mbrasId={mbrasId}
            mbrasNm={pickedMbrasNm}
            mbrasAtrzDocId={mbrasAtrzDocId}
            setModalOpen={setModalOpen}
            setCallTime={setCallTime}
          />
        </div>
      </Modal>
    </div>
  );
};

export default MbrasWhdwlMng;
